import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import Request, { ApiMode } from '../../utils/request';
import FormGenerator, { FormTypes } from '../../components/FormGenerator';
import { scrollToNode } from '../../utils/misc';

const SELECTOR_WRAPPER = '.p-lta-secure-form';
const SELECTOR_FORM_WRAPPER = '.lta-secure-form-form';
const SELECTOR_FORM_BUTTON = '.js-submit-secure-form';

const SELECTOR_SUCCESS_WRAPPER = '.lta-secure-form__success__wrapper';
const SELECTOR_FORM_SECTION = '.lta-secure-form__content';
const SELECTOR_ERROR_WRAPPER = '.lta-secure-form__error-wrapper';
const SELECTOR_ERROR_BUTTON = '.lta-secure-form__error-btn';

const KEY_OBJECT = 'fieldName';
const VALUE_OBJECT = 'value';

const CLICK_EVENT = 'click';
const HIDDEN_CLASS = 'u-hidden';

const IS_LOCAL = false;

class secureOnlineForm {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		this.formElementsList = {};
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	get stepsData() {
		return this._stepsData;
	}

	set stepsData(_stepsData) {
		this._stepsData = _stepsData;
		if (_stepsData?.length > 0) {
			this.initiateFormGenerator(_stepsData);
		}
	}

	init() {
		this.secureFormSection = SelectorEngine.findOne(SELECTOR_FORM_SECTION, this._wrapper);
		this.secureForm = SelectorEngine.findOne(SELECTOR_FORM_WRAPPER, this._wrapper);
		this.secureFormButton = SelectorEngine.findOne(SELECTOR_FORM_BUTTON, this._wrapper);
		this.secureFormSuccess = SelectorEngine.findOne(SELECTOR_SUCCESS_WRAPPER, this._wrapper);
		this.errorWrapper = SelectorEngine.findOne(SELECTOR_ERROR_WRAPPER, this._wrapper);
		this.errorMessage = this.errorWrapper.getAttribute('data-field-error');
		this.errorMessageApi = this.errorWrapper.getAttribute('data-api-error');
		this.errorText = SelectorEngine.findOne('.lta-snackbar__label', this.errorWrapper);
		this.errorBtn = SelectorEngine.findOne(SELECTOR_ERROR_BUTTON, this.errorWrapper);
		this.getSupportFormDetails();
	}
	initiateFormGenerator(stepsData) {
		this.formGenerator = new FormGenerator(this.secureForm, {
			questions: stepsData,
			totalSteps: 3,
			hasSeparator: false,
			formType: FormTypes.SectionForm,
			themeColor: 'color-lta-accent-orange',
			isHideProgress: true,
			isRenderDependentQuestion: false
		});
		this.formGenerator.onChange((answers) => {
			this.prepareRequestObject(answers);
		});
		EventHandler.on(this.secureFormButton, CLICK_EVENT, () => {
			const isFormValid = this.formGenerator.formValidation();
			if (!isFormValid) {
				this.errorWrapper.classList.remove(HIDDEN_CLASS);
				this.errorText.innerHTML = this.errorMessage;
				scrollToNode(this.errorWrapper);
			} else {
				this.submitSupportForm(this.answerList);
			}
		});
		EventHandler.on(this.errorBtn, CLICK_EVENT, () => {
			this.errorWrapper.classList.add(HIDDEN_CLASS);
		});
	}
	prepareRequestObject(stepsAnswers) {
		this.answerList = {};
		for (const stepKey in stepsAnswers) {
			const stepAnswersObjects = stepsAnswers[stepKey];
			for (const questionKey in stepAnswersObjects) {
				const answerObject = stepAnswersObjects[questionKey];
				const formatObject = {};
				formatObject[answerObject[KEY_OBJECT]] = answerObject[VALUE_OBJECT];
				this.answerList = {
					...this.answerList,
					...formatObject
				}
			}
		}
	}
	async getSupportFormDetails() {
		try {
			const url = '/api/coachinformation/steps';
			const response = await Request.get(
				url,
				{},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { Steps, error } = response;
			if (Steps) {
				this.stepsData = Steps;
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}

	async submitSupportForm(answerObject) {
		const requestObject = {
			coachName: answerObject?.coachName,
			coachCode: answerObject?.coachCode,
			contactEmail: answerObject?.contactEmail,
			contactNumber: answerObject?.contactNumber,
			accountNumber: answerObject?.accountNumber,
			sortCode: answerObject?.sortCode,
			payeeName: answerObject?.payeeName
		};
		try {
			const url = '/api/coachinformation/CoachSecureInformation';
			const response = await Request.post(url, requestObject, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
				}
			});
			const { Success } = response;
			if (Success) {
				this.secureFormSection.classList.add(HIDDEN_CLASS);
				this.secureFormSuccess.classList.remove(HIDDEN_CLASS);
				scrollToNode(this.secureFormSuccess);
			} else {
				this.errorWrapper.classList.remove(HIDDEN_CLASS);
				this.errorText.innerHTML = this.errorMessageApi;
				scrollToNode(this.errorWrapper);
			}
		} catch (error) {
			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}
}

const globalSecureOnlineForm = new secureOnlineForm();
export default globalSecureOnlineForm;
